/* insmia-reviews.js — PDP 评论区增强
 * ② Judge.me 评论默认按「Pictures first」排(带图的顶上去)
 * ④ 购买区星标可点击 → 平滑滚到评论区
 *
 * 注:「无评论商品显示其他商品评论」曾在此自定义实现,2026-09-02 已撤除 ——
 *    Judge.me Review Widget 区块原生就有该设置(If no reviews show → Reviews for other products),
 *    用原生的,别再在这里造。
 *
 * 约束:
 * - 只在 /products/ 页生效; 排除 PLP 商品卡里的 .rating-wrapper
 * - 用户手动改过排序后, 本次会话不再强改(sessionStorage 守卫)
 * - Judge.me widget 异步渲染 → MutationObserver 等它出现, 有超时上限不空转
 */
(function () {
  'use strict';

  var WIDGET_ID = 'judgeme_product_reviews';
  var SORT_SEL = 'select.jdgm-sort-dropdown, select.jm-sort-filter__select';
  var WANT_SORT = 'pictures_first';
  var SS_KEY = 'insmia_reviews_sort_touched';
  var MAX_WAIT_MS = 20000;

  function isProductPage() {
    return location.pathname.indexOf('/products/') !== -1;
  }

  /* ---------- ④ 星标点击跳转 ---------- */
  function wireStarJump() {
    if (!isProductPage()) return;
    var wraps = document.querySelectorAll('.rating-wrapper');
    for (var i = 0; i < wraps.length; i++) {
      var w = wraps[i];
      if (w.closest('.product-card, .card-gallery, .product-grid')) continue;  // PLP 卡片不做跳转
      if (w.hasAttribute('data-ins-jump')) continue;
      w.setAttribute('data-ins-jump', '1');
      w.setAttribute('role', 'button');
      w.setAttribute('tabindex', '0');
      w.setAttribute('aria-label', 'Read customer reviews');
      w.addEventListener('click', jumpToReviews);
      w.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); jumpToReviews(); }
      });
    }
  }

  function jumpToReviews() {
    var t = document.getElementById(WIDGET_ID) ||
            document.querySelector('.jdgm-review-widget');
    if (t) t.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  /* ---------- ② 默认按带图优先排序 ---------- */
  function applySort(sel) {
    if (!sel || sel.dataset.insSorted === '1') return;
    try { if (sessionStorage.getItem(SS_KEY) === '1') { sel.dataset.insSorted = '1'; return; } } catch (e) {}
    var has = false;
    for (var i = 0; i < sel.options.length; i++) {
      if (sel.options[i].value === WANT_SORT) { has = true; break; }
    }
    if (!has || sel.value === WANT_SORT) { sel.dataset.insSorted = '1'; return; }
    sel.dataset.insSorted = '1';
    sel.value = WANT_SORT;
    sel.dispatchEvent(new Event('change', { bubbles: true }));
    sel.addEventListener('change', function () {
      try { sessionStorage.setItem(SS_KEY, '1'); } catch (e) {}
    });
  }

  /* ---------- 启动 ---------- */
  function boot() {
    wireStarJump();
    applySort(document.querySelector(SORT_SEL));

    var host = document.getElementById(WIDGET_ID) || document.body;
    var started = Date.now();
    var mo = new MutationObserver(function () {
      wireStarJump();
      applySort(document.querySelector(SORT_SEL));
      if (Date.now() - started > MAX_WAIT_MS) mo.disconnect();
    });
    mo.observe(host, { childList: true, subtree: true });
    setTimeout(function () { mo.disconnect(); }, MAX_WAIT_MS);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
